module.exports = __webpack_public_path__ + "static/media/wrecker_blue.744742fc.svg";